<svelte:options customElement={{ tag: "app-loginform", shadow: "none" }} />

<script>
  let error = null;
  let username = "";
  let password = "";
  let platform = "devplatform";

  async function login() {
    error = null;
    const form = new FormData();
    form.append("username", username);
    form.append("password", password);
    form.append("platform", platform);

    const loginProcedure = await window.api.authentication.login.mutate({
      username: username,
      password: password,
      platform: platform
    })

    if (loginProcedure.type == "error") {
      error = loginProcedure.message;
      return;
    }

    if (loginProcedure.type == "success" && loginProcedure.token) {
      // 3 Hours
      document.cookie = loginProcedure.cookieData;
      document.cookie = loginProcedure.cookieDataExpiry
      location.href = '/login/2fa'
    }
  }
</script>

<section class="container container-tight py-4">
  <div class="text-center mb-4">
    <a href="/" class="navbar-brand navbar-brand-autodark">
      <img
        src="https://gamepoint.tech/images/common/logos/logo_gpinternational_frontpage.png"
        alt=""
        width="300"
      />
    </a>
  </div>

  {#if error != null}
    <div class="alert alert-danger">{error}</div>
  {/if}

  <div class="card card-md">
    <div class="card-body">
      <h2 class="h2 text-center mb-4">Login with your GamePoint AD credentials</h2>
      <form on:submit|preventDefault={login}>
        <div class="mb-3">
          <!-- svelte-ignore a11y-label-has-associated-control -->
          <label class="form-label" for="username">Email or Username</label>
          <input
            type="text"
            class="form-control"
            bind:value={username}
            name="username"
            placeholder="jdevries@gamepoint.com"
          />
        </div>

        <div class="mb-2">
          <!-- svelte-ignore a11y-label-has-associated-control -->
          <label class="form-label" for="password">Password</label>
          <div class="input-group input-group-flat">
            <input
              type="password"
              class="form-control"
              bind:value={password}
              name="password"
            />
          </div>
        </div>

        <div class="form-footer">
          <button type="submit" class="btn btn-primary">Signin</button>
          or
          <a href="/login" class="btn btn-4">Go back</a>
        </div>
      </form>
    </div>
  </div>
</section>
